import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';

@Component({
  selector: 'app-bread-crumb',
  templateUrl: './bread-crumb.component.html',
  styleUrls: []
})
export class BreadCrumbComponent implements OnInit {

  currentRoute: string;

  constructor(router: Router) {
    router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
      )
      .subscribe(
        (event: NavigationEnd) => {
          if (event.url === '/') {
            this.currentRoute = event.url + 'home';
          } else {
            this.currentRoute = event.url;
          }
        });
  }

  ngOnInit(): void {

  }

  isInHome() {
    return this.currentRoute !== '/home';
  }

  getSubPath() {

    if (this.currentRoute !== '/home') {
      const subPaths = this.currentRoute.split('/');
      return '/' + subPaths[subPaths.length - 1];
    }
    return ' ';
  }

}
